import { render, staticRenderFns } from "./share-popup.vue?vue&type=template&id=50141914&scoped=true&"
import script from "./share-popup.vue?vue&type=script&lang=js&"
export * from "./share-popup.vue?vue&type=script&lang=js&"
import style0 from "./share-popup.vue?vue&type=style&index=0&id=50141914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50141914",
  null
  
)

export default component.exports